<template>
  <div class="page">
    <div class="page-padding">
      <figure class="visual">
        <picture>
          <source media="(min-width: 550px)" srcset="img/visual-bahnziele.jpg">
          <img src="img/visual-bahnziele-small.jpg"/>
        </picture>
        <figcaption>
          <h1>Bahnziele</h1>
        </figcaption>
      </figure>
      <h2 class="carousel-headline">Unsere Filme zum Thema Bahnziele</h2>
      <bahnziele-movies-list></bahnziele-movies-list>
    </div>
  </div>
</template>

<script>

import BahnzieleMoviesList from './BahnzieleMoviesList.vue';

export default {
  components: {
    bahnzieleMoviesList: BahnzieleMoviesList
  },
  beforeRouteEnter(to, from, next) {
    window.scrollToTop();
    next();
  },
}
</script>



// WEBPACK FOOTER //
// Bahnziele.vue?95db3d9c